import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { Flex } from '@magnetic/flex';
import { Header } from '../common/header';
import Footer from '../common/footer';
import { WidgetContainer } from '../common/styled-widget';
import { Banner } from '../common/banner';
import Occupancy from '../floor/components/occupancy';
import FloorSelector from '../floor/components/floor-selector';
import { BuildingViewAnalytics } from './analytics-widget';
import SingleFloor from './single-floor';
import { getContext, getLocation } from '../redux/spaces-slice';
import { CustomeMask } from '../common/styled-widget';
import FloorView from '../floor/layout';
import { getSelectedLocation } from '../redux/spaces-slice';
import { useTranslation } from 'react-i18next';
import { getCurrentSlide } from '../../../store/uislice';
const BuildingContainer = styled(Flex) `
  width: 97vw;
  height: 97vh;
  padding: 1.5vh 1.5vw;
  overflow: hidden;
  background: black;
`;
const GraphWidget = ({ isSingleFloor, occupancy }) => (_jsxs(WidgetContainer, Object.assign({ width: isSingleFloor && occupancy ? 1780 : 1225, height: occupancy ? 495 : 267, color: '#1D2023', align: "flex-start", justify: "space-between", style: {
        padding: '20px',
        minHeight: !isSingleFloor ? '70vh' : '',
        overflowY: 'auto',
    } }, { children: [occupancy && (_jsx(Flex, Object.assign({ basis: isSingleFloor ? 1130 : 780 }, { children: _jsx(Occupancy, { isSingleFloor: isSingleFloor }) }))), _jsx(Flex, Object.assign({ style: { marginTop: '2vh' } }, { children: _jsx(BuildingViewAnalytics, { occupancy: occupancy }) }))] })));
const getFloorSelector = (maskRequired, currentSlide, isNonInteractiveCarouselView, floorCount) => {
    return (_jsxs(Flex, Object.assign({ direction: "vertical" }, { children: [_jsxs(WidgetContainer, Object.assign({ direction: "vertical", height: isNonInteractiveCarouselView ? '840' : '790', overflowy: true, color: '#1D2023', align: "flex-start", justify: "space-between", padding: "0px", width: 530, id: "building-floor-selector" }, { children: [_jsx(FloorSelector, {}), maskRequired && !isNonInteractiveCarouselView && (_jsx(CustomeMask, { className: "mask" }))] })), isNonInteractiveCarouselView && (_jsx(Flex, Object.assign({ justify: "space-between", style: {
                    marginTop: '-1vw',
                    width: '4vw',
                    height: '1vw',
                    marginLeft: '44.4%',
                } }, { children: [...Array(Math.ceil(floorCount / 12)).keys()].map((i) => {
                    return (_jsx(_Fragment, { children: _jsx("div", { style: {
                                width: '0.4vw',
                                height: '0.4vw',
                                borderRadius: '0.6vw',
                                background: currentSlide === i + 1 ? 'white' : 'black',
                                border: '1px solid white',
                            } }) }));
                }) })))] })));
};
const BannerWidget = ({ bannerText, occupancy }) => (_jsx(WidgetContainer, Object.assign({ width: 1260, height: occupancy ? 223 : 446, align: "center", justify: "center" }, { children: _jsx(Banner, { title: bannerText }) })));
const SingleFloorWidget = ({ fullHeight }) => (_jsx(WidgetContainer, Object.assign({ width: 530, height: fullHeight ? 780 : 223, align: "center" }, { children: _jsx(SingleFloor, { fullHeight: fullHeight }) })));
const FloorContent = ({ isSingleFloor, bannerText, occupancy, maskRequired, currentSlide, isNonInteractiveCarouselView, floorCount, }) => (_jsxs(Flex, Object.assign({ gap: 24 }, { children: [_jsxs(Flex, Object.assign({ gap: 24, grow: true, basis: 1260, direction: "verticle" }, { children: [_jsx(GraphWidget, { isSingleFloor: isSingleFloor, occupancy: occupancy }), _jsx(Flex, Object.assign({ justify: "space-between" }, { children: isSingleFloor && occupancy && (_jsx(SingleFloorWidget, { fullHeight: !occupancy })) }))] })), !isSingleFloor &&
            getFloorSelector(maskRequired, currentSlide, isNonInteractiveCarouselView, floorCount), isSingleFloor && !occupancy && _jsx(SingleFloorWidget, { fullHeight: true })] })));
export function BuildingView() {
    const dispatch = useDispatch();
    const selectedFloor = useSelector(getSelectedLocation);
    const locationData = useSelector(getLocation);
    const context = useSelector(getContext);
    const buildingConfig = context.appConfig.building;
    const buildingOccupancy = buildingConfig.showBuildingOccupancy;
    const currentSlide = useSelector(getCurrentSlide);
    const { t } = useTranslation();
    const floorCount = locationData.children.length;
    const isNonInteractiveCarouselView = !(context === null || context === void 0 ? void 0 : context.interactive) && floorCount > 12;
    const text = `${t('building.enabling-a')} <span style="font-weight: 900; font-family: CiscoSansRegular">${t('building.safe')}</span>, <span style="font-weight: 900; font-family: CiscoSansRegular">${t('building.smart')}</span>, and <span style="font-weight: 900; font-family: CiscoSansRegular">${t('building.collaborative')}</span> ${t('building.experience')}`;
    const [isSingleFloor, setIsSingleFloor] = useState(false);
    const [name, setName] = useState('');
    const [maskRequired, setMaskRequired] = useState(false);
    const isSignageInteractive = context === null || context === void 0 ? void 0 : context.interactive;
    useEffect(() => {
        var _a, _b;
        if (locationData === null || locationData === void 0 ? void 0 : locationData.name) {
            setName(locationData === null || locationData === void 0 ? void 0 : locationData.name);
            setMaskRequired(((_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) === null || _a === void 0 ? void 0 : _a.length) > 3);
            setIsSingleFloor(((_b = locationData === null || locationData === void 0 ? void 0 : locationData.children) === null || _b === void 0 ? void 0 : _b.length) === 1);
        }
    }, [locationData]);
    useEffect(() => {
        function blockAllClicks(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
        // Capture phase = true
        if (!isSignageInteractive) {
            window.addEventListener('click', blockAllClicks, true);
            return () => window.removeEventListener('click', blockAllClicks, true);
        }
    }, []);
    // Sync local state with Redux for backward compatibility
    useEffect(() => {
        console.log('@@@@ Building selectedFloor :', selectedFloor);
    }, [selectedFloor]);
    return (_jsxs("div", Object.assign({ style: {
            position: 'relative',
            width: '100vw',
            minHeight: '100vh',
            overflow: 'hidden',
        } }, { children: [_jsx("div", Object.assign({ style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    zIndex: 1,
                } }, { children: _jsx(FloorView, { id: selectedFloor }) })), (!selectedFloor || selectedFloor.trim() === '') && (_jsx("div", Object.assign({ style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '104vh',
                    background: 'black',
                    zIndex: 2,
                    display: 'flex',
                    flexDirection: 'column',
                } }, { children: _jsxs(BuildingContainer, Object.assign({ gap: 24, direction: "verticle", justify: "space-between" }, { children: [_jsx(Header, { title: name }), _jsx(FloorContent, { isSingleFloor: isSingleFloor, bannerText: text, occupancy: buildingOccupancy, maskRequired: maskRequired, currentSlide: currentSlide, isNonInteractiveCarouselView: isNonInteractiveCarouselView, floorCount: floorCount }), _jsx(Flex, Object.assign({ style: { marginTop: '-2vw' } }, { children: _jsx(Footer, {}) }))] })) })))] })));
}
export default BuildingView;
